import GlobalLinks from './GlobalLinks'
export default GlobalLinks
